import { apiSlice } from '../../app/api/apiSlice';
import { GetSpecialPackageData, GetSpecialPackageResponse } from '../../types/response';
import { CreatePackageRequestBody, UpdatePackageItemRequestBody, UpdateSpecialPackageItemRequestBody, UpdateSpecialPackageDetailsRequestBody, CreateSpecialPackageRequestBody } from './packageRequestBody';
import { PackageResponseData, CreateNewPackageResponse, PackagesResponse, DefaultPackagesResponse, DefaultPackageData, PackageResponse, PackageProductsData, PackageProductsResponse, PackageSummaryOfClient, ClientPackageSummaryResponse } from './packageResponse';
import { PackageStatus } from './packageSlice';

export const packageApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllPackage: builder.query<PackageResponseData, void>({
            query: () => '/api/fnb/packages',
            transformResponse: (response: PackagesResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: [{ type: 'Package', id: 'LIST' }],
        }),

        createNewPackage: builder.mutation<CreateNewPackageResponse, CreatePackageRequestBody>({
            query: (newPackageForm) => ({
                url: '/api/fnb/packages',
                method: 'POST',
                body: newPackageForm,
            }),
            invalidatesTags: [{ type: 'Package', id: 'LIST' }],
        }),

        createNewPackageItems: builder.mutation<PackageResponse, { packageID: number; productIDs: number[] } >({
            query: ({ packageID, productIDs }) => ({
                url: `/api/fnb/packages/${packageID}/items`,
                method: 'POST',
                body: { productIDs },
            }),
            invalidatesTags: [{ type: 'Package', id: 'LIST' }],
        }),

        updatePackageDetails: builder.mutation<PackageResponse, { packageId: number; packageDetails: CreatePackageRequestBody }>({
            query: ({ packageId, packageDetails }) => ({
                url: `/api/fnb/packages/${packageId}`,
                method: 'PATCH',
                body: packageDetails,
            }),
            invalidatesTags: (result, error, { packageId }) => [
                { type: 'Package', id: 'LIST' },
                { type: 'Package', id: packageId },
            ],
        }),

        updatePackageItem: builder.mutation<PackageResponse, UpdatePackageItemRequestBody>({
            query: (data) => ({
                url: `/api/fnb/packages/items/products`,
                method: 'PUT',
                body: data
            }),
            invalidatesTags: [{ type: 'Package', id: 'LIST' }],
        }),

        getPackageItems: builder.query<PackageProductsData, number | undefined>({
            query: (packageID) => `/api/fnb/packages/${packageID}/items`,
            transformResponse: (response: PackageProductsResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: (result, error, packageID ) => [
                { type: 'Package', id: 'LIST' },
                { type: 'Package', id: packageID },
            ],
        }),

        // get promo/default packages
        getDefaultPackages: builder.query<DefaultPackageData, void>({
            query: () => '/api/defaultpackage',
            transformResponse: (response: DefaultPackagesResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: [{ type: 'Package', id: 'LIST' }],
        }),

        // default promo/package items
        // getDefaultPackageItems: builder.query<PackageResponseItems['data'], void>({
        //     query: () => '/api/defaultpackage/items',
        //     transformResponse: (response: PackageResponseItems) => response.data,
        //     transformErrorResponse: (response) => response.data,
        //     providesTags: [{ type: 'Package', id: 'LIST' }],
        // }),

        // set default promo/package
        // setDefaultPackagePromo: builder.mutation<SetDefaultPackageResponse['data'], number>({
        //     query: (packageID) => ({
        //         url: `/api/defaultpackage/${packageID}`,
        //         method: 'PUT',
        //         body: { packageID },
        //     }),
        //     invalidatesTags: (result, error,  packageID) => [
        //         { type: 'Package', id: 'LIST' },
        //         { type: 'Package', id: packageID },
        //     ],
        // }),

        //get package base on chapel id
        // getPackageBaseOnChapelId: builder.query<PackageOfChapel[], number | undefined>({
        //     query: (chapelId) => `/api/chapel/${chapelId}/packages`,
        //     transformResponse: (response: FetchPackageBaseOnChapelIdResponse) => response.data,
        //     transformErrorResponse: (response) => response.data,
        // }),

        getPackageSummaryBaseOnId: builder.query<PackageSummaryOfClient[], number | undefined>({
            query: (clientID) => `/api/clients/${clientID}/package/summary`,
            transformResponse: (response: ClientPackageSummaryResponse) => response.data.packageSummary,
            transformErrorResponse: (response) => response.data,
            providesTags: (result, error,  clientID) => [
                { type: 'Package', id: 'LIST' },
                { type: 'Client', id: 'LIST' },
                { type: 'Client', id: clientID },
                { type: 'Package', id: clientID },
            ],
        }),

        // setDefaultPackage: builder.mutation<SetDefaultPackageResponse, number>({
        //     query: (packageID) => ({
        //         url: `/api/defaultpackage/${packageID}`,
        //         method: 'PUT',
        //     }),
        //     invalidatesTags: ['Package'],
        // }),

        updatePackageStatus: builder.mutation<PackageResponse, { type: PackageStatus, packageId: number }>({
            query: ({type, packageId}) => ({
                url: `/api/fnb/packages/${packageId}/${type}`,
                method: 'PUT',
            }),
            invalidatesTags: (_result, _error, { packageId }) => [
                { type: 'Package', id: packageId },
                { type: 'Package', id: 'LIST' },
            ],
        }),
        
        getSpecialPackages: builder.query<GetSpecialPackageData[], void>({
            query: () => `api/fnb/special-packages`,
            transformResponse: (response: GetSpecialPackageResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: [
                { type: 'SpecialPack', id: 'LIST' },
                { type: 'Package', id: 'LIST' },
            ],
        }),

        // SPECIAL
        createNewSpecialPackage: builder.mutation<CreateNewPackageResponse, CreateSpecialPackageRequestBody>({
            query: (specialPackageForm) => ({
                url: '/api/fnb/packages',
                method: 'POST',
                body: specialPackageForm,
            }),
            invalidatesTags: [{ type: 'Package', id: 'LIST' }],
        }),
        updateSpecialPackageStatus: builder.mutation<PackageResponse, { type: PackageStatus, packageId: number }>({
            query: ({type, packageId}) => ({
                url: `/api/fnb/special-packages/${packageId}/${type}`,
                method: 'PUT',
            }),
            invalidatesTags: (_result, _error, { packageId }) => [
                { type: 'Package', id: packageId },
                { type: 'Package', id: 'LIST' },
            ],
        }),
        updateSpecialPackageDetails: builder.mutation<PackageResponse, { packageId: number, body: UpdateSpecialPackageDetailsRequestBody }>({
            query: ({body, packageId}) => ({
                url: `/api/fnb/special-packages/${packageId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: (_result, _error, { packageId }) => [
                { type: 'Package', id: packageId },
                { type: 'Package', id: 'LIST' },
            ],
        }),
        updateSpecialPackageItem: builder.mutation<PackageResponse, { packageId: number, body: UpdateSpecialPackageItemRequestBody }>({
            query: ({body, packageId}) => ({
                url: `/api/fnb/special-packages/${packageId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: (_result, _error, { packageId }) => [
                { type: 'Package', id: packageId },
                { type: 'Package', id: 'LIST' },
            ],
        }),
    }),
});

export const { 
    useGetAllPackageQuery,
    useCreateNewPackageMutation,
    useCreateNewPackageItemsMutation,
    useGetPackageItemsQuery,
    // useGetDefaultPackageItemsQuery,
    useGetDefaultPackagesQuery,
    // useSetDefaultPackagePromoMutation,
    // useGetPackageBaseOnChapelIdQuery,
    useGetPackageSummaryBaseOnIdQuery,
    // useSetDefaultPackageMutation,
    useUpdatePackageDetailsMutation,
    useUpdatePackageItemMutation,
    useUpdatePackageStatusMutation,

    useGetSpecialPackagesQuery,


    //SPECIAL
    useCreateNewSpecialPackageMutation,
    useUpdateSpecialPackageDetailsMutation,
    useUpdateSpecialPackageItemMutation,
    useUpdateSpecialPackageStatusMutation,
} = packageApiSlice;